<template>
    <div>
        <TopBar title="CONTACT US" :showBack="true" @onClickBack="clickBack()" />
        <div class="text-center content">
            <div class="title">{{ lbl.contact_us.title }}</div>
            <div class="line"></div>
            <div>
                <div>{{ lbl.contact_us.hotlineLabel }}:</div>
                <div>
                    <img class="img-icon" src="@/assets/icon/phone-icon.png" />
                    {{ lbl.contact_us.hotline }}
                </div>
            </div>
            <div class="pt-4">
                <div>{{ lbl.contact_us.emailLabel }}:</div>
                <div>
                    <img class="img-icon" src="@/assets/icon/email-icon.png">
                    {{ lbl.contact_us.email }}
                </div>
            </div>
            <div class="pt-4" @click="clickContactForm()">
                <div class="pb-3">{{ lbl.contact_us.onlineContactLabel }}:</div>
                <a href="https://shop.dior.co.th/pages/contact-us">
                    <Blackbtn>CONTACT FORM</Blackbtn>
                </a>
            </div>
            <div style="padding-top:38px">
                <div class="pb-3">
                    <img class="img-icon" src="@/assets/icon/calendar-icon.png" />
                    {{ lbl.contact_us.days }}
                </div>
                <div v-for="(hour,index) in splitHours()" :key="index">
                    <img class="img-icon" src="@/assets/icon/time-icon.png" />
                    {{ hour }}
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import TopBar from "@/components/TopBar.vue";
import Blackbtn from "../components/button/BlackBtn";
import Locale from "@/helper/locale/locale.js";
import { TrackingService } from "@/helper/TrackingHelper";
export default {
    name: 'Contactus',
    components:{
        TopBar,
        Blackbtn
    },
    data: function() {
        return {
            lbl: Locale.getLbl(),
            tracking: new TrackingService(this)
        };
    },

    mounted() {

    },

    methods: {
        splitHours: function(){
            let splitMsg = this.lbl.contact_us.hours.split(";");
            return splitMsg
        },
        clickBack: function(){
            this.$router.back()
            this.tracking.event('Menu_contact_us', 'click_back');
        },
        clickContactForm: function() {
            this.tracking.event('Menu_contact_us', 'click_contact_form');
        }
    },
};
</script>

<style lang="scss" scoped>
.title{
    font-size: 18px;
    font-weight: bold;
    padding-top: 33px
}
.content{
    margin: 3px 60px 38px 60px;
    font-size: 15px;
}
.line{
  height: 1px;
  margin: 20px 0 26px 0;
  transform: rotate(-180deg);
  background-color: #ccc;
}
.img-icon{
    width: 15px;
}
</style>
